import _get from 'lodash/get'

const getTemplatePartScene = (state, part) => {
  return _get(state, `defaultTemplate.template.${part}.scene`)
}

export default getTemplatePartScene
